import React from 'react'
import { FaGithub } from 'react-icons/fa';
import { IconContext } from 'react-icons';


function GitHub({ fontSize, color,background }) {
  return (
    <IconContext.Provider value={{ style: { fontSize, color ,background} }}>
    <div><FaGithub /></div>
    
  </IconContext.Provider>
  )
}

export default GitHub